<template>
  <b-card>
    <FloodingMap />
    <b-row>
      <b-col
        cols="12"
        class="mt-1 mb-1"
      >
        <span style="font-size:16px; color: #fff;">ตารางรายละเอียดเซ็นเซอร์</span>
      </b-col>
      <b-col
        cols="12"
        sm="12"
      >
        <b-table
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(devstate)="data">
            <b-link
              v-b-modal="'modalLog'"
              @click="$refs.childref.eventFlooding(data.item.deveui)"
            >
              <feather-icon
                v-if="data.value === '0' "
                icon="AlertCircleIcon"
                size="24"
                style="color:grey"
              />
              <feather-icon
                v-else
                icon="AlertCircleIcon"
                size="24"
                style="color: #ff3838"
              />
            </b-link>
          </template>
          <template #cell(devdesc)="data">
            {{ data.item.deveui }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <FloodingModal ref="childref" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BTable, BBadge, BLink, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import FloodingMap from '@/views/flooding/detail/FloodingMap.vue'
import FloodingModal from './FloodingModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,
    BTable,
    BBadge,
    // FloodingCCTV,
    FloodingMap,
    FloodingModal,
  },
  data() {
    return {
      fields: [
        {
          key: 'devdesc', label: 'ชื่อ', sortable: true, class: 'text-center',
        },
        {
          key: 'devstate', label: 'ความสูงน้ำ', sortable: true, class: 'text-center',
        },
        {
          key: 'status', label: 'สถานะ', class: 'text-center', sortable: true,
        },
        {
          key: 'lastupdate', label: 'อัพเดทล่าสุด', class: 'text-center', sortable: true,
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Online: 'Online', Offline: 'Offline',
      },
      {
        Online: 'light-success', Offline: 'light-danger',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getFlooding()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getFlooding()
    }, 300000)
  },
  methods: {
    getFlooding() {
      axios
        .post('/getFloodingSensor', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
